// src/context/themeConfig.js
// Firestore config/theme ドキュメントをリアルタイム購読し、テーマ設定を配信する
import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../api/firebase";

// デフォルト値（Firestoreにドキュメントがない場合のフォールバック）
export const THEME_DEFAULTS = {
  // 角丸
  borderRadius: 14,
  cardRadius: 18,
  buttonRadius: 999,
  chipRadius: 999,
  menuRadius: 16,
  menuItemRadius: 10,
  paperRadius: 18,
  dialogRadius: 20,

  // ムードカラー
  seiPrimary: "#334155",
  seiBg: "#f7f7fb",
  waPrimary: "#2E4E3F",
  waBg: "#f6f2ea",
  douPrimary: "#7c2d12",
  douBg: "#f6f7fb",
};

const ThemeConfigContext = createContext(THEME_DEFAULTS);

export function ThemeConfigProvider({ children }) {
  const [config, setConfig] = useState(THEME_DEFAULTS);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "config", "theme"),
      (snap) => {
        if (snap.exists()) {
          setConfig({ ...THEME_DEFAULTS, ...snap.data() });
        }
      },
      (err) => {
        console.warn("テーマ設定の読み込みに失敗:", err);
      }
    );
    return unsub;
  }, []);

  return (
    <ThemeConfigContext.Provider value={config}>
      {children}
    </ThemeConfigContext.Provider>
  );
}

export function useThemeConfig() {
  return useContext(ThemeConfigContext);
}
